import { useNavigate } from 'react-router-dom';
import { Container, PageHeader } from '@vnetwork/ui/layout';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@vnetwork/ui/primitives';
import { type FilterField } from '@vnetwork/ui/data';
import { employeeColumns } from './employee-list-columns';
import { EmployeeListSection } from './employee-list-section';
import { EmployeeDepartmentsSection } from './employee-departments-section';
import type { EmployeeRecord } from '@/api/employees';

const FILTER_FIELDS: FilterField[] = [
  {
    value: 'employee_contract_type',
    label: 'Contract type',
    input: 'select',
    options: [
      { value: 'intern', label: 'Intern' },
      { value: 'probation', label: 'Probation' },
      { value: 'official', label: 'Official' },
      { value: 'collaborator', label: 'Collaborator' },
      { value: 'advisor', label: 'Advisor' },
    ],
  },
  {
    value: 'employee_gender',
    label: 'Gender',
    input: 'select',
    options: [
      { value: 'male', label: 'Male' },
      { value: 'female', label: 'Female' },
      { value: 'other', label: 'Other' },
    ],
  },
];

/**
 * Employees list page — three tabs mirroring the legacy Employee module:
 * Active (employee_status=1), Resigned (employee_status=0), Departments.
 * Route: /employees
 */
export default function EmployeesPage() {
  const navigate = useNavigate();

  const onRowClick = (row: EmployeeRecord) => {
    navigate(`/employees/${row.employee_id}`);
  };

  return (
    <Container size="full">
      <PageHeader
        title="Employees"
        description="Manage employee records, departments, and employment lifecycle."
      />

      <Tabs defaultValue="active">
        <TabsList style={{ marginBottom: 'var(--vn-space-4)' }}>
          <TabsTrigger value="active">Active</TabsTrigger>
          <TabsTrigger value="resigned">Resigned</TabsTrigger>
          <TabsTrigger value="departments">Departments</TabsTrigger>
        </TabsList>

        <TabsContent value="active">
          <EmployeeListSection
            statusFilter={[1]}
            columns={employeeColumns}
            filterFields={FILTER_FIELDS}
            onRowClick={onRowClick}
          />
        </TabsContent>

        <TabsContent value="resigned">
          <EmployeeListSection
            statusFilter={[0]}
            columns={employeeColumns}
            filterFields={FILTER_FIELDS}
            onRowClick={onRowClick}
          />
        </TabsContent>

        <TabsContent value="departments">
          <EmployeeDepartmentsSection />
        </TabsContent>
      </Tabs>
    </Container>
  );
}
